<template>
  <div id="app" @mousemove="handleMouseMove">
    <Transition name="fade">
      <header class="fixed top-0 left-0 right-0 h-20 text-white p-5 z-10 home-header" v-if="shouldShowHeader"
        :class="{ 'header-visible': isHeaderActive }">
        <nav class="flex justify-around items-center h-full">
          <div class="text-xl font-bold app-log ">
            <a href="/"><img src="./assets/img/logo.png" alt style="" class="logo_img" /></a>
          </div>
          <div class="text-xl"> </div>
          <!-- 手机端菜单图标 -->
          <div v-if="isMobile" class="cursor-pointer" @click="toggleMobileMenu">
            <svg class="w-10 h-10 text-black" fill="none" stroke="currentColor" viewBox="0, 0, 24, 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </div>
          <!-- 导航菜单 -->
          <ul
            :class="{ 'flex space-x-16': !isMobile, 'flex-col space-y-4 absolute top-full  text-white  right-0 bg-stone-50 opacity-75 p-5': isMobile && showMobileMenu }">
            <li> <router-link to="/" class="nav-link" @click="hideMobileMenuIfMobile">首页</router-link> </li>
            <li> <router-link to="/product" class="nav-link" @click="hideMobileMenuIfMobile">RANYU产品介绍</router-link>
            </li>
            <a href="https://zb.ranyu.vip" class="nav-link" target="_blank">主播云工作台</a>
            <!-- <li>
              <a href="javascript:;" class="nav-link" @click.prevent="showModaltoZB = true;">主播云工作台</a>
            </li> -->
            <li><router-link to="/join" class="nav-link" @click="hideMobileMenuIfMobile">加入我们</router-link> </li>
            <!-- <li><router-link to="/train" target="" class="nav-link" @click="hideMobileMenuIfMobile">主播培训</router-link> </li> -->
            <li class="relative">
              <a href="javascript:;" class="nav-link"
                @click.prevent="showModal = true; toggleQrCode; hideMobileMenuIfMobile">下载APP</a>
            </li>
          </ul>
        </nav>
      </header>
    </Transition>

    <main :class="mainContentClasses">
      <router-view></router-view>
    </main>
    <!-- 自定义模态框 -->
    <div v-if="showModal" class="modal-overlay" @click="showModal = false">
      <div class="modal-content">
        <p>即将上线 敬请期待...</p>
      </div>
    </div>
    <!-- 自定义主播端弹窗 -->
    <div v-if="showModaltoZB" class="modal-overlay" @click="showModaltoZB = false">
      <div class="modal-content">
        <p>请联系您的星探，获取主播资格！</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted, onBeforeUnmount, watchEffect, watch, provide } from 'vue'
import { useRoute } from 'vue-router'
import FooterInfo from './components/FooterInfo.vue'
const route = useRoute()
const showQrCode = ref(false)
const showMobileMenu = ref(false)
const isMobile = ref(window.innerWidth < 768)
const showModal = ref(false)
const showModaltoZB = ref(false)
const currentSlideIndex = ref(0)
const isMouseInTopArea = ref(false)
const headerTriggerThreshold = 80 // 顶部80px触发区域
const isHome = computed(() => route.path === '/')
const handleMouseMove = (e) => {
  isMouseInTopArea.value = e.clientY < headerTriggerThreshold
}
// Header激活状态
const isHeaderActive = computed(() => {
  if (!isHome.value) return true // 非首页始终激活
  let viewportWidth = window.innerWidth;
  console.log("视口宽度: " + viewportWidth);
  if (viewportWidth < 767) {
    return true
  } else {
    return currentSlideIndex.value === 0 || isMouseInTopArea.value
  }
})
// Header显示判断
const shouldShowHeader = computed(() => {
  if (!isHome.value) return true // 非首页始终显示
  let viewportWidth = window.innerWidth;
  console.log("视口宽度: " + viewportWidth);
  if (viewportWidth < 767) {
    return true
  } else {
    return currentSlideIndex.value === 0 || isMouseInTopArea.value

  }
})
const isShowFooter = computed(() => {
  if (isHome.value) return false // 非首页始终显示
  return currentSlideIndex.value === 1
})
// 暴露更新方法
provide('updateSlideIndex', (index) => {
  currentSlideIndex.value = index
})
// 轮播索引变化自动隐藏
watch(currentSlideIndex, (newVal) => {
  if (newVal > 0) isMouseInTopArea.value = false
})


const mainContentClasses = computed(() => ({
  'main-home': isHome.value,
  'main-other': !isHome.value
}))

// 切换二维码显示
const toggleQrCode = () => {
  showQrCode.value = !showQrCode.value
}

// 切换手机端菜单显示
const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value
}

// 点击外部区域关闭二维码
const handleClickOutside = (event) => {
  const qrCode = document.querySelector('.relative > img')
  const trigger = document.querySelector('.relative > a')
  if (!qrCode || !trigger) return
  if (!qrCode.contains(event.target) && !trigger.contains(event.target)) {
    showQrCode.value = false
  }
}

// 监听窗口大小变化
const handleResize = () => {
  isMobile.value = window.innerWidth < 768
  if (!isMobile.value) {
    showMobileMenu.value = false
  }
}

// 若为移动端，点击菜单项后隐藏菜单
const hideMobileMenuIfMobile = () => {
  if (isMobile.value) {
    showMobileMenu.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
  window.removeEventListener('resize', handleResize)
})

// 初始加载时检查窗口大小
watchEffect(() => {
  isMobile.value = window.innerWidth < 768
})
</script>

<style scoped lang="scss">
// 添加全局响应式变量
$breakpoint-sm: 480px;
$breakpoint-md: 768px;

#app {
  width: 100vw;
  height: 100vh;
  position: relative;
  padding: 0;
}

.home-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5rem;
  color: white;
  z-index: 1000;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(-100%);
  opacity: 0;
  will-change: transform, opacity;

  @media (max-width: 767px) {
    padding: 0px;
    height: 3rem;
  }
}

.header-visible {
  transform: translateY(0);
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.main-home {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.main-other {
  position: relative;
  top: 80px;
  overflow-y: auto;
  height: calc(100vh - 80px);

  @media (max-width: 767px) {
    top: 3rem;
    height: calc(100vh - 3rem);
  }

}

.nav-link {
  color: #000000;
}

// 二维码样式
.relative>img {
  z-index: 100;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1);
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.514);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: rgba(6, 6, 6, 0.536);
  padding: 20px;
  color: #fff;
  text-align: center;
}
</style>

<style lang="scss">
::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}

.glo-footer {
  background: rgb(245, 245, 245);
}

.logo_img {
  width: 154px;
  height: 46px;
}

$mobile-font-size: 1.2rem;

/* 手机端适配 */
@media (max-width: 767px) {
  #app {
    padding: 0px;
    max-width: 767px;
  }

  nav ul {
    display: none;
  }

  nav ul.flex-col {
    display: flex;
  }

  h2 {
    font-size: $mobile-font-size * 1.5 !important;
  }

  p {
    font-size: 0.75rem;
  }

  .mt-2 {
    font-size: 0.65rem;
    line-height: 0.75rem;
  }

  .mt-3 {
    display: none;
  }

  .p-6 {
    padding: 0.65rem;
  }

  .logo_img {
    width: 130px;
    height: 40px;
  }



}
</style>